import React from 'react';
import { Modal } from 'react-bootstrap';
import FixIncompleteBookingForm from './FixIncompleteBookingForm';

interface FixIncompleteBookingModalProps {
    show: boolean;
    bookingRoomId: string;
    onClose: () => void;
    onSuccess?: () => void;
    onOpenFullEdit?: (bookingId: string) => void;
}

const FixIncompleteBookingModal: React.FC<FixIncompleteBookingModalProps> = ({ show, bookingRoomId, onClose, onSuccess, onOpenFullEdit }) => {
    return (
        <Modal show={show} onHide={onClose} centered size="lg" backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>Fix Incomplete Booking</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {show && (
                    <FixIncompleteBookingForm
                        bookingRoomId={bookingRoomId}
                        onClose={onClose}
                        onSuccess={onSuccess}
                        onOpenFullEdit={onOpenFullEdit}
                    />
                )}
            </Modal.Body>
        </Modal>
    );
};

export default FixIncompleteBookingModal;
